module.exports = __webpack_public_path__ + "804fda8acdb54d59d5ddcd686593a974.svg";